import React from "react";
import PropTypes from "prop-types";
import { ltiLaunch } from "../../../fraction/ui/utils/location";

class RedirectContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      requiresUserPermission: Fraction.Helpers.Locations.requiresRedirectWarning(
        this.props.url
      ),
      blockRedirect: Fraction.Helpers.Locations.blockRedirect(this.props.url)
    };

    this._performRedirect = this._performRedirect.bind(this);
    this._goBack = this._goBack.bind(this);
  }

  componentDidMount() {
    Fraction.Helpers.removeLoader("body");
    Fraction.Helpers.removeLoader("header");
    if (!this.state.requiresUserPermission && !this.state.blockRedirect) {
      this._performRedirect();
    }
  }

  _performRedirect(e) {
    const { type, roles, allQueries, lti, url, old, sso } = this.props;
    if (!this.state.blockRedirect) {
      e && e.preventDefault();
      if (lti) {
        ltiLaunch(Fraction.User, type, false, roles, allQueries);
      } else if (sso) {
        Fraction.Helpers.Locations.ssoToOldOnlineURL(url, false, old);
      } else {
        // redirect knowing it is safe
        Fraction.Helpers.Locations.safeRedirect(url, false, true);
      }
    }
  }

  _goBack() {
    window.history.back();
  }

  render() {
    return (
      <div className="redirect-container">
        <div className="redirect-message">
          <h1>{i18n.t("messages.about-to-be-redirected")}</h1>
          <div className="redirect-description">
            {i18n.t("base.to")} {this.props.label || this.props.url}.&nbsp;
            {(this.state.requiresUserPermission ||
              this.state.blockRedirect) && (
              <span>{i18n.t("messages.could-not-verify-identity")}</span>
            )}
          </div>
          {(this.state.requiresUserPermission || this.state.blockRedirect) && (
            <div>
              <button className="submit gray" onClick={this._goBack}>
                {i18n.t("messages.go-back")}
              </button>
              {!this.state.blockRedirect && (
                <button className="submit" onClick={this._performRedirect}>
                  {i18n.t("messages.back-to-site")}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

RedirectContainer.propTypes = {
  url: PropTypes.string,
  old: PropTypes.string,
  lti: PropTypes.string,
  type: PropTypes.string,
  isbn: PropTypes.string,
  label: PropTypes.string,
  roles: PropTypes.string
};

RedirectContainer.defaultProps = {
  url: "",
  old: ""
};

module.exports = RedirectContainer;
